import React, { useState } from "react";
import {
  Box,
  Typography,
  LinearProgress,
  Paper,
  Button,
  Divider,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import Target from "../../assets/Target.png"
import reward_girl from "../../assets/reward_girl.png"
import QuickScan from "../../assets/QuickScan.gif"


import Game from "../Game/component";
import CircularProgressBar from "./CircularProgressBar";
import DaalchiniLogo from '../../assets/dalchini_icon.png'
import backArrow from '../../assets/backArrow.png'

import {  IconButton} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Guidelines from "../Game/Guidelines";
import GiftCouponCard from "./GiftCouponCard";
import ApplyCouponPopUp from "./ApplyCouponPopUp";
import BalanceBottomSheet from "./buyOrder/Component";
import TagOrderVmInventory from "./buyOrder/container";
import CouponList from "./buyOrder/CouponList";
import WaitingLoder from "../../Loader/component";
import CashbackCard from "./CashBacKCard";


const defaultPgName = localStorage.getItem("defaultPgName");




const TagOrder = ({machineId,loader,paymentStatusFlag,setPaymentStatusFlag,handleStartWebSocket,reward,couponsList,applyCoupon,couponAppliedSuccess,CouponText,handleCloseCouponPopup,showCouponPopFlag}) => {
const navigate=useNavigate()
     const location = useLocation()
      
        
     const params = new URLSearchParams(location.search);
     const value = params.get("value");
     console.log("tagOrderId",value)
    const [gameguideLine,setGameguidelines]=useState(false)
    const [orderNowFlag,setOrderNowFlag]=useState(false)

    const handleOrderNow=()=>{
      setOrderNowFlag(true)
    }

  const handleBack=()=>{
navigate(`/`)
  }
const milestoneToFind = reward?.currentLevelMilestoneCount;

const rewardValue = reward?.levelRewards.find(
  (item) => item.milestoneCount === milestoneToFind
);

// get its value if found
const CashBackvalue = rewardValue ? rewardValue.value : null;

console.log("reward", reward);

  return (
    <>
    {loader&&<WaitingLoder/>}
{    orderNowFlag&&<TagOrderVmInventory handleStartWebSocket={handleStartWebSocket} paymentStatusFlag={paymentStatusFlag} setPaymentStatusFlag={setPaymentStatusFlag} setOrderNowFlag={setOrderNowFlag} machineId={machineId}/>
}           {showCouponPopFlag&& <ApplyCouponPopUp
            CouponText={CouponText}
            handleCloseCouponPopup={handleCloseCouponPopup}
            couponAppliedSuccess={couponAppliedSuccess}
            machineId={machineId}
          />}

              {couponAppliedSuccess&& <ApplyCouponPopUp
            CouponText={CouponText}
            handleCloseCouponPopup={handleCloseCouponPopup}
            couponAppliedSuccess={couponAppliedSuccess}
            machineId={machineId}
          />}
    <>
  
    {gameguideLine?
    <Guidelines setGameguidelines={setGameguidelines} tagOrder={true}/>:

    <>{/* <MyHeader handleBack={handleBack}/> */}
    <Box
      sx={{
        background: "#fff",
        minHeight: "100vh",
        p: 2,
       
        mx: "auto",
      }}
    >
      {/* Milestone Info */}
      <Box textAlign="center " display={"flex"} alignItems={"center"} justifyContent={"space-between"} style={{paddingTop:"70px"}}> 
        <Typography sx={{ color: "#8d6e63", fontWeight: 600 }}>
          You're On <span style={{ color: "#d67f00" }}>Milestone {reward?.currentLevelMilestoneCount}</span>
        </Typography>

        <Box position="relative" display="inline-flex" mt={1}>
         <CircularProgressBar value={ (reward?.currentLevelMilestoneCount / reward?.totalMilestones) * 100}/>
        </Box>
      </Box>

      {/* Surprise Offer Card */}
      {CashBackvalue?
      <Paper
        elevation={3}
        sx={{
          mt: 2,
          p: 1.5,
          borderRadius: 2,
          border: "1px solid #90caf9",
         background: "linear-gradient(90deg, #DEFEE6 0%, #FFFFC7 100%)"

        }}
      >
        <Box style={{display:"flex",alignItems:"center"}}>
            <img src={reward_girl} style={{width:"60px"}}/>
        <Box style={{    marginLeft: "10px"}}>
        <Typography sx={{ fontWeight: 700, color: "#2e7d32" }}>
          Woohoo! 🎉
        </Typography>
        <Typography sx={{ color: "#28863B", fontSize: "14px", }}>
          A Surprise Offer Has Been Applied
        </Typography>
        </Box>
        </Box>
      </Paper> :

     <Paper
        elevation={3}
        sx={{
          mt: 2,
          p: 1.5,
          borderRadius: 2,
          border: "1px solid #90caf9",
         background: " linear-gradient(90deg, #DEFEE6 0%, #FFFFC7 100%)"

        }}
      >
        <Box style={{display:"flex",alignItems:"center"}}>
            <img src={QuickScan} style={{width:"60px"}}/>
        <Box style={{    marginLeft: "10px"}}>
        <Typography sx={{ fontWeight: 700, color: "rgb(245, 109, 12)" }}>
          Earn More!
        </Typography>
        <Typography sx={{ color: "rgb(245, 109, 12)", fontSize: "14px", }}>
         No offer this time, but you're getting closer 
        </Typography>
        </Box>
        </Box>
      </Paper> }

      {/* Game Progress Image */}
      <Box sx={{ mt: 2, textAlign: "center" }}>
    { reward&&<Game data={reward} route={`/tagOrderId?value=${value}`}  tagOrder={true}  setGameguidelines={setGameguidelines}/>}
      </Box>

      {/* Scan Info */}
<div
  style={{
    border: "1px solid rgb(217, 203, 183)",
    borderRadius: "12px",
    padding: "20px",
    display: "inline-block",
    textAlign: "center",
    backgroundColor: "white",
    width: "100%",
  
  }}
>
 <div
  style={{
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    lineHeight: 1.5,
    letterSpacing: "0.00938em",
    color: "rgb(160, 82, 45)",
    fontWeight: 700,
    fontSize: "12px",
    margin: "0px",
  }}
>
 Scan On Every Order To Unlock Surprise Coupons
</div>

</div>


      {/* Active Order */}
      {CashBackvalue&&
       /*  <>   

      <Paper
        elevation={2}
        sx={{
          mt: 1,
          p: 2,
          borderRadius: 2,
          //background: "#f1f8e9",
          border: "1px solid #c8e6c9",
          background: "linear-gradient(90deg, #DEFEE6 0%, #FFFFC7 100%)"

        }}
      >
        <Typography sx={{ color: "#555", fontSize: "13px" }}>
          Order ID: {value}
        </Typography>
        <Typography
          sx={{ color: "#2e7d32", fontWeight: 600, fontSize: "16px", mt: 0.5 }}
        >
          Cashback Won
        </Typography>
        <div style={{display:"flex",    justifyContent: "space-between"}}>
           
    
        <Typography
          sx={{
            color: "#1b5e20",
            fontSize: "22px",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            mt: 0.5,
          }}
        >
          ₹{CashBackvalue} <Typography sx={{ fontSize: "13px", ml: 1 }}></Typography>
        </Typography>
        <img src={ RupeeCoinGift} style={{width:"50px",    marginTop: "-41px",    justifyContent: "space-between"}}/>
            </div>
                <Button
                  onClick={(e)=>{handleOrderNow()}}
                      variant="contained"
                      sx={{
                        backgroundColor: "#FFFFFF",
                        color: "#0D8A28",
                        borderRadius: "50px",
                        width: "100%",
                        border: "2px solid #0D8A28",
                        fontWeight: 700,
                        fontSize: "18px",
                        textTransform: "none",
                        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                        "&:hover": { backgroundColor: "#F2FFF2" },
                      }}
                    >
                      ORDER NOW
                    </Button>
      </Paper></> */
      
   
      <CashbackCard orderId={value} handleOrderNow={handleOrderNow} CashBackvalue={CashBackvalue}/>
      }

      {/* Coupons */}
    
     {<div>
      {couponsList&&couponsList[0]?<>
   
  <CouponList couponsList={couponsList} applyCoupon={applyCoupon} reward={reward}/>
   
      </>:<><GiftCouponCard  machineId={machineId}/></>}
      </div>}

    </Box>
    </>
}</>
    </>
  );
};



export default TagOrder;
